import React, { createContext, useContext, PropsWithChildren } from "react";
import { TFunction } from "i18next";

const defaultT = (key: string) => { console.info("[SchemaProvider.defaultT]", key); return key; };

interface ISchemaContextData {
    translate: TFunction
    addTranslationResource: (lang: string, ns: string, tarnslations: { [key: string]: string }) => void;
};

const initialContext: ISchemaContextData = {
    translate: defaultT,
    addTranslationResource: () => { }
}

const configContext = createContext<ISchemaContextData>(initialContext);

export const useSchemaContext = () => useContext(configContext) || initialContext;

interface SchemaProviderProps extends Partial<ISchemaContextData> { };

export const SchemaProvider: React.FC<PropsWithChildren<SchemaProviderProps>> = ({
    children,
    translate = defaultT,
    addTranslationResource = () => { }
}) => {

    const { Provider } = configContext;

    const value = {
        translate,
        addTranslationResource
    }

    return (
        <Provider value={value}>
            {children}
        </Provider>
    );

};